export const name = 'rnRecordCollectionFactory';

export default function rnRecordCollectionFactory() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var factory = {
    create: createCollection
  };
  return factory;

  /////////////////

  function createCollection(data) {
    var collection = {
      canCreate: canCreate,
      canNew: canNew,
      getLink: getLink
    };

    activate();

    return collection;

    /////////////////

    function activate() {
      // Bind server returned data to do this object
      _.extend(collection, data);
    }

    function canCreate() {
      return hasLink('create') || hasLink('add');
    }

    function canNew() {
      return hasLink('new');
    }

    function hasLink(linkName) {
      return getLink(linkName) !== undefined;
    }

    function getLink(linkName) {
      let links;
      if(_.has(data, '_links')) {
        links = data._links;
      }
      else if (_.has(data, 'links')) {
        console.warn('Collection has unconventional property "links".  APIs should provide "_links" instead. Collection: ');
        console.dir(data);
        links = data.links;
      }

      if(links) {
        return links[linkName];
      }
      return undefined;
    }
  }
}
